import { render } from "./EmptyCalendar.vue.js?vue&type=template&id=2b7e5724!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EmptyCalendar.vue?vue&type=template&id=2b7e5724"
import script from "./EmptyCalendar.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EmptyCalendar.vue?vue&type=script&lang=js"
export * from "./EmptyCalendar.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EmptyCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__